export const LADE_ADRESSMELDUNG = 'ladeAdressmeldung'
export const LADE_ADRESSDATEN = 'ladeAdressdaten'
